<template>
  <div v-if="autoCampaign" class="auto-campaign-show-section">
  <h1 class="page-header text-center">autoconnect: {{autoCampaign.header}}</h1>

    <div v-if="errorMessage" class="error-label text-center">{{errorMessage}}</div>

    <div class="row">
      <div class="large-12 columns">
        <div class="data-title text-center auto-campaign-name">{{autoCampaign.name}}</div>
        <div class="data-title text-center auto-campaign-status">
          status: <span :class="enabledStatus">{{enabledStatus}}</span>
        </div>

        <settings-show :autoCampaign="autoCampaign"></settings-show>

        <div v-if="!isBrandFollowUpType" class="divider"></div>

        <template v-if="autoCampaign.scopes">
          <scope-show v-for="scope in autoCampaign.scopes"
                      :key="scope.id"
                      :allowMultiMessages="autoCampaign.allow_multi_messages"
                      :autoCampaignId="autoCampaign.id"
                      :isBudzAutoCampaign="autoCampaign.type === 16"
                      :isBrandFollowUpAC="isBrandFollowUpType"
                      :scope="scope"></scope-show>
        </template>
      </div>
    </div>

    <div class="row">
      <div class="large-8 columns small-centered center-button">
        <a v-if="autoCampaign && hasAccessToAutoCampaign(userAbilitiesValue, 'EDIT', autoCampaign)"
           class="button auto-campaign-edit-button"
           :href="`/auto_campaigns/${autoCampaign.id}/edit`">edit autoconnect</a>
      </div>
    </div>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import CommunicationShowMixin from '../../mixins/CommunicationShowMixin'
  import LoadErrorMixin from '../../mixins/LoadErrorMixin'
  import RemoveRailsLoadingMixin from '../../mixins/RemoveRailsLoadingMixin'
  import ScopeShow from '../../components/AutoCampaigns/ScopeShow'
  import SettingsShow from '../../components/AutoCampaigns/SettingsShow'
  import { mapGetters } from 'vuex'
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'

  export default {
    name: 'AutoCampaignShow',

    components: {
      ScopeShow,
      SettingsShow,
    },

    mixins: [AxiosMixin, CommunicationShowMixin, LoadErrorMixin, RemoveRailsLoadingMixin, UserAbilitiesMixin],

    data() {
      return {
        autoCampaign: null,
        autoCampaignId: null,
        errorText: 'we encountered an issue loading the autoconnect details.',
        scopeMessages: null,
      }
    },

    methods: {
      loadAutoCampaign() {
        const url = `/api/v3/auto_campaigns/${this.autoCampaignId}`
        this.axiosMethod({url, onSuccess: this.setAutoCampaignData, onError: this.setLoadError})
      },

      setAutoCampaignData(data) {
        if (data && data.auto_campaign) {
          this.autoCampaign = data.auto_campaign
          this.errorMessage = null
        } else {
          this.errorMessage = this.errorText
        }
      },
    },

    created() {
      this.$store.dispatch('LOAD_CURRENT_USER')
      this.$store.dispatch('LOAD_CURRENT_MERCHANT')
      this.autoCampaignId = this.$route.params.id
      this.loadAutoCampaign()
    },

    mounted() {
      this.removeLoading('campaign-show-loading-icon')
    },

    computed: {
      isBrandFollowUpType() {
        return this.autoCampaign?.type === 20
      },

      enabledStatus: function() {
        return this.autoCampaign && this.autoCampaign.enabled ? 'enabled' : 'disabled'
      },

      ...mapGetters([
        'userAbilitiesValue'
      ])
    },
  }
</script>